module.exports = __webpack_public_path__ + "assets/b531468e36cb0a5b26a1d492cd050846.png";